module.exports = __webpack_public_path__ + "static/media/layer3-box.52fc98b7.png";